import { Controller } from "@hotwired/stimulus";
import { Slideshow } from "../components/slideshow/Slideshow";

// Lifecycle wrapper around Slideshow. connect() starts cycle2 playback;
// disconnect() tears it down, preventing leaks when the DOM is replaced
// (turbo-stream, Sortable drag-and-drop, etc.).
export default class extends Controller {
  connect() {
    this.slideshow = new Slideshow(this.element);
    this.slideshow.init();
  }

  disconnect() {
    // Sortable re-inserts moved elements, triggering disconnect on a node
    // that is still in the document. Don't tear down in that case — Stimulus
    // will not call connect() again for an element that was never truly removed.
    if (this.element.isConnected) return;

    this.slideshow?.destroy();
    this.slideshow = null;
  }
}
